// ============================================================================
// Urgency vocabulary shared by lab / imaging / referral / ambulance orders.
// The backend accepts any of these strings and uses them for routing + SLAs.
// ============================================================================

export const URGENCY = Object.freeze(['routine', 'urgent', 'stat'])

export const URGENCY_DEFAULT = 'routine'

// Ambulance requests use a DIFFERENT vocabulary from labs/imaging because
// the backend `AmbulanceRequest.URGENCY_CHOICES` is fixed by clinical
// convention (routine / priority / emergency, not stat). Keep this list
// in sync with `clinical_notes/models.py::AmbulanceRequest.URGENCY_CHOICES`.
export const URGENCY_AMBULANCE = Object.freeze(['routine', 'priority', 'emergency'])
export const URGENCY_AMBULANCE_DEFAULT = 'priority'

// Ambulance "service type" is orthogonal to urgency — urgency answers
// "how fast?", service type answers "what kind of transport?". A
// dialysis run can be routine urgency; a routine transport can
// deteriorate into an emergency en route. The backend field is a free
// CharField so other PNG operators can pick custom labels, but the
// doctor's CNE form (AmbulanceForm.jsx) and the patient marketplace
// (PatientAmbulanceBrowser.jsx) should default to this curated list
// so dispatch queues read consistently.
export const AMBULANCE_SERVICE_TYPES = Object.freeze([
  'Routine transport',
  'Inter-facility transfer',
  'ICU transfer',
  'Emergency response',
  'Dialysis run',
  'Maternity transport',
])
export const AMBULANCE_SERVICE_TYPE_DEFAULT = 'Routine transport'
